/**
 * Settings Manager - LocalStorage persistence
 */

const STORAGE_KEY = 'dexa-settings';

/**
 * Check if device is mobile
 * @returns {boolean}
 */
function isMobile() {
  return window.innerWidth <= 768 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

/**
 * Get default settings based on device
 * @returns {Object}
 */
function getDefaultSettings() {
  return {
    editorTheme: 'oneDark',
    layout: isMobile() ? 'vertical' : 'horizontal',
    swapped: false,
    showUniforms: true,
  };
}

/**
 * Load settings from localStorage
 * @returns {Object} Settings object
 */
export function loadSettings() {
  const defaults = getDefaultSettings();

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Only use stored layout if it exists, otherwise use device-appropriate default
      return {
        ...defaults,
        ...parsed,
        layout: parsed.layout || defaults.layout,
      };
    }
  } catch (e) {
    console.warn('Failed to load settings:', e);
  }
  return defaults;
}

/**
 * Save settings to localStorage
 * @param {Object} settings - Settings to save
 */
export function saveSettings(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    console.warn('Failed to save settings:', e);
  }
}

/**
 * Update a single setting
 * @param {string} key - Setting key
 * @param {*} value - Setting value
 */
export function updateSetting(key, value) {
  const settings = loadSettings();
  settings[key] = value;
  saveSettings(settings);
}

/**
 * Get a single setting
 * @param {string} key - Setting key
 * @returns {*} Setting value
 */
export function getSetting(key) {
  const settings = loadSettings();
  return settings[key];
}
